import type { PurposeConsents, VendorConsents, VendorsList } from "../analytics/cmp/types";
import { AppEvent } from ".";

type ConsentRejectedDetail = {
  type: "consentRejected";
  vendorsList: VendorsList;
  vendorConsents: VendorConsents;
  purposeConsents: PurposeConsents;
};

export class ConsentRejectedEvent extends AppEvent<ConsentRejectedDetail> {
  constructor({ vendorsList, vendorConsents, purposeConsents }: Omit<ConsentRejectedDetail, "type">) {
    super({ type: "consentRejected", vendorsList, vendorConsents, purposeConsents });
  }
}
